export default {
    coverage_details_title: "Detalles de Cobertura",
    coverage_details_no_details: "Sin Detalles",
    coverage_details_address:"Dirección",
    coverage_details_coordinates:"Coordenadas",
    coverage_details_hdop:"HDop",
    coverage_details_heartbeat:"Heartbeat",
    coverage_details_installed:"Instalada",
    coverage_details_rssi: "RSSI",
    coverage_details_pass:"Paso",
    coverage_details_fail:"Falla, dar Click para conocer los detalles",
    coverage_details_score:"Puntaje de Cobertura",
    coverage_details_updated_on: "Actualización de la Coberturan",
    coverage_details_update_diagnostic: "Actualizar Diagnóstico",
    coverage_details_diagnostic_details: "Detalles del Diagnóstico",

    coverage_details_input: "IMEI o serie",
    coverage_details_imei: "IMEI",
    coverage_details_serial: "Serie",
    coverage_details_model: "Modelo",
    coverage_details_change: "Cambiar",
    coverage_details_no_devices_added: "No se han añadido dispositivos",
    coverage_details_device_is_already_added: "El dispositivo ya está añadido",
    coverage_details_device_has_not_been_found: "No se ha encontrado el dispositivo",
    coverage_details_this_feature_is_not_available: "Esta función no está disponible",
    coverage_details_single_success_message: "El dispositivo ha sido marcado como RMA",
    coverage_details_multiple_success_message: "Los dispositivos han sido marcados como RMA",
    coverage_details_error_message: "No se puede marcar como RMA debido a un error",
    coverage_details_show_in_web: "Mostrar en la Web",
    coverage_details_number: "Número RMA",
    coverage_details_device_is_already_rma: "El dispositivo ya está marcado como RMA",
    coverage_details_device_is_already_refirbished: "El dispositivo ya está remanufacturado",
    coverage_details_devices_is_already_rma: "Hay dipositivos que ya estan marcados como RMA",
    coverage_details_devices_is_already_refirbished: "Hay dispositivos que ya fueron remanufacturados",
    coverage_details_min_message: "El número RMA debe tener al menos 5 digitos"
}